import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Page } from 'src/app/shared/shared.model';
import { ConfigService } from 'src/app/shared/config/config.service';
import {
  ResidentsQuery,
  Resident,
  ResidentDetails,
  UpdateEndOfLease,
  ReturnSecurityDeposit,
  GetFullInsightReportViewModel
} from '../models/residents.model';
import { ResidentGlobalSearchResult } from '../../common/models/global-search.model';

@Injectable({ providedIn: 'root' })
export class ResidentsService {

  private config;

  constructor(
    configService: ConfigService,
    private http: HttpClient
  ) {
    this.config = configService.getConfig()!;
  }

  getResidentsPage(query: ResidentsQuery): Observable<Page<Resident>> {
    return this.http.get(
      `${this.config.securityDepositBaseUrl}/manager/residents`,
      { params: query as any }
    );
  }

  getResidentDetails(residentId: string): Observable<ResidentDetails> {
    return this.http.get<ResidentDetails>(
      `${this.config.securityDepositBaseUrl}/manager/residents/${residentId}`
    )
  }

  getFullInsightReport(model: GetFullInsightReportViewModel) {
    const params: Record<string, boolean> = {};
    if (model.isOptIn !== null && model.isOptIn !== undefined) {
      params.isOptIn = model.isOptIn;
    }
    return this.http.get(`${this.config.securityDepositBaseUrl}/manager/residents/full-insight-report`,
      { params, responseType: 'arraybuffer' });
  }

  returnSD(model: ReturnSecurityDeposit) {
    return this.http.post<void>(
      `${this.config.securityDepositBaseUrl}/manager/payments/residents/${model.residentId}/refund`,
      model
    );
  }

  updateEndOfLease(model: UpdateEndOfLease): Observable<void> {
    return this.http.post<void>(
      `${this.config.securityDepositBaseUrl}/manager/residents/lease`, model)
  }

  getGlobalSearchResults(search: string): Observable<ResidentGlobalSearchResult> {
    return this.http.get<ResidentGlobalSearchResult>(
      `${this.config.securityDepositBaseUrl}/manager/residents/global/search`,
      { params: { search } }
    );
  }
}
